import Flex from '@Components/Bases/Flex';
import OtherExplanations from '@Containers/OtherExplanations';
import { useGetEsgDataPlatform } from '@Domains/Esg/EsgDataPlatform';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import EsgPlatFormCheckComplete from './Components/EsgPlatFormCheckComplete';
import EsgPlatformFooter from './Containers/EsgPlatformFooter';
import EsgPlatformFormProvider from './Containers/EsgPlatformFormProvider';
import { IEsgDataPlatformFormValues } from './Containers/EsgPlatformFormProvider/types';
import EsgPlatformScore from './Containers/EsgPlatformScore/EsgPlatformScore';
import EsgPlatformOverview from './Containers/Overview/EsgPlatformOverview';
import { mapEsgDataPlatformToFormValues } from './utils';

const EsgPlatform = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const currentPath = location.pathname.split('/').pop();
  const [{ data, loading, error }, refetch] = useGetEsgDataPlatform(id);
  useEffect(() => {
    if (currentPath === 'platform') {
      refetch().catch((err) => {
        if (err.name !== 'CanceledError') {
          console.error('Failed to fetch esg platform :', err);
        }
      });
    }
  }, [currentPath, refetch]);
  if (loading) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress size={50} />
      </Flex>
    );
  }

  if (error) {
    return (
      <Box p={2}>
        <Alert severity={'error'}>
          ไม่สามารถโหลดข้อมูลการเปิดเผยข้อมูลจาก ESG Data Platform
        </Alert>
      </Box>
    );
  }

  const initialValues: IEsgDataPlatformFormValues =
    mapEsgDataPlatformToFormValues(data);

  return (
    <EsgPlatformFormProvider initialValues={initialValues}>
      <form>
        <Flex flexDirection={'column'} gap={2} p={2} mb={8}>
          <Typography variant="h3">ส่วนที่ 3 แผนการยกระดับ</Typography>
          <EsgPlatformOverview />
          <EsgPlatformScore />
          <OtherExplanations />
          <EsgPlatFormCheckComplete />
        </Flex>
        <EsgPlatformFooter />
      </form>
    </EsgPlatformFormProvider>
  );
};

export default EsgPlatform;
